export default __webpack_public_path__ + "static/media/612c8c707462e51c.b89a9c36181485a04cf56af5e0a4d1df.svg";